"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametricsSchema = void 0;
const zod_1 = require("zod");
const ParameterValue_1 = require("../ParameterValue");
exports.ParametricsSchema = zod_1.z
    .object({
    supplyVoltage: ParameterValue_1.ParameterValueSchema.optional(),
    maxCurrentConsumption: ParameterValue_1.ParameterValueSchema.optional(),
    radioFrequency: ParameterValue_1.ParameterValueSchema.optional(),
    signalLevel: ParameterValue_1.ParameterValueSchema.optional(),
    maxCurrent: ParameterValue_1.ParameterValueSchema.optional(),
    isFloating: ParameterValue_1.ParameterValueSchema.optional(),
    isActiveLow: ParameterValue_1.ParameterValueSchema.optional(),
    fetDrive: ParameterValue_1.ParameterValueSchema.optional(),
    pinPullup: ParameterValue_1.ParameterValueSchema.optional(),
    pullupResistance: ParameterValue_1.ParameterValueSchema.optional(),
    pullupVoltageSignal: ParameterValue_1.ParameterValueSchema.optional(),
    differentialSignal: ParameterValue_1.ParameterValueSchema.optional(),
    differentialPolarity: ParameterValue_1.ParameterValueSchema.optional(),
    clampUpSignal: ParameterValue_1.ParameterValueSchema.optional(),
    clampDownSignal: ParameterValue_1.ParameterValueSchema.optional(),
})
    .catchall(ParameterValue_1.ParameterValueSchema.optional());
//# sourceMappingURL=Parametrics.js.map